module.exports = __webpack_public_path__ + "static/img/12.226cbb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/12.png
// module id = I8VR
// module chunks = 2